type ItemShare = { amountCents: number; assignedTo: string }

// An empty assignee shares that item among the selected people. Keep zero
// shares so someone who paid for the whole bill can owe none of it.
export function itemizedSplits(items: ItemShare[], participantIDs: string[]) {
  if (!participantIDs.length || new Set(participantIDs).size !== participantIDs.length) return null
  const totals = new Map(participantIDs.map((id) => [id, 0]))
  for (const item of items) {
    if (!Number.isSafeInteger(item.amountCents) || item.amountCents <= 0) return null
    const recipients = item.assignedTo ? [item.assignedTo] : participantIDs
    if (recipients.some((id) => !totals.has(id))) return null
    const share = Math.floor(item.amountCents / recipients.length)
    const remainder = item.amountCents % recipients.length
    recipients.forEach((id, index) => totals.set(id, totals.get(id)! + share + (index < remainder ? 1 : 0)))
  }
  const result = [...totals].map(([personId, amountCents]) => ({ personId, amountCents }))
  return result.every((split) => Number.isSafeInteger(split.amountCents)) ? result : null
}
